import React, { useEffect, useState } from 'react'
import Select from 'react-select'
import { setDropdownValue } from '../../Store/reducers/common'
const SingleSelect = (props) => {
  const {
    options,
    placeholder,
    setFieldValue,
    name,
    isClearable = true,
    value,
    disabled,
    setFieldValueFull,
    className,
    dispatch,
    notRefresh,
    formikRef,
  } = props
  const [selectOptions, setselectOptions] = useState([])
  const [selectLabel, setSelectLabel] = useState(
    value !== '' ? value : placeholder,
  )
  useEffect(() => {
    let label = placeholder
    if (value !== '') {
      const selected = options?.find((ele) => ele.id === value)
      if (selected) {
        label = selected.name
      }
    }
    if (!notRefresh) {
      setSelectLabel(label)
    }
  }, [placeholder, value])
  useEffect(() => {
    if (options) {
      setselectOptions(
        options?.map((op) => {
          return {
            label: op.name,
            value: op.id,
            ...op,
          }
        }),
      )
    }
  }, [props.options])
  return (
    <Select
      options={selectOptions}
      placeholder={selectLabel}
      onChange={(e) => {
        if (e?.value) {
          if (setFieldValueFull || formikRef) {
            formikRef?.current?.setFieldTouched(name)
            setFieldValueFull(name, e)
          } else if (setFieldValue) {
            setFieldValue(name, e.value)
          }
        } else {
          if (setFieldValueFull) {
            setFieldValueFull(name, '')
          } else if (setFieldValue) {
            setFieldValue(name, '')
          }
        }

        if (dispatch) {
          dispatch(setDropdownValue({ ...e, name }))
        }
      }}
      isClearable={isClearable}
      isSearchable
      isDisabled={disabled}
      className="hema-single-select"
    />
  )
}

export default SingleSelect
